/**
 * Los atajos de teclado globales (A aprobar, R cambios, ← →…) no deben dispararse cuando la
 * persona está escribiendo: foco en un campo de texto, un diálogo abierto (buscador ⌘K) o una
 * combinación con Ctrl/⌘/Alt. Aprobar con una sola tecla mientras se tipea en la búsqueda
 * podía decidir una pieza sin querer.
 */
export function ignorarAtajo(e) {
  if (e.defaultPrevented || e.isComposing || e.metaKey || e.ctrlKey || e.altKey) return true;
  const t = e.target;
  if (t && t.nodeType === 1) {
    const tag = t.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || t.isContentEditable) return true;
  }
  if (typeof document !== "undefined" && document.querySelector('[role="dialog"][aria-modal="true"]')) return true;
  return false;
}
